import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import PanelHeader from "./common/PanelHeader";
import SummaryBlock from "./common/SummaryBlock";
import ListItemCard from "./common/ListItemCard";
import ActionButtonRow from "./common/ActionButtonRow";

export default function AccountRenewalsPanel({ summaryItems = [], renewals = [], buttons = [], detailed = false }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        p: 2,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        bgcolor: "background.default",
      }}
    >
      <PanelHeader
        title="Account Renewals"
        subtitle="Credit card annual fee renewals and benefits"
        statusChip={<Chip label="2 need attention" color="error" size="small" />}
      />
      <SummaryBlock items={summaryItems} columns={3} />
      <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2 }}>
        Upcoming Renewals
      </Typography>
      {renewals.map((r, idx) => (
        <Box key={idx} sx={{ mb: 2 }}>
          <ListItemCard {...r} />
          {detailed && r.benefits && r.benefits.length > 0 && (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
              {r.benefits.map((b, i) => (
                <Chip key={i} label={b} size="small" color="default" />
              ))}
            </Box>
          )}
        </Box>
      ))}
      <ActionButtonRow buttons={buttons} />
    </Box>
  );
}
